"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initCaptcha = exports.captcha = void 0;
const env_1 = require("../../env");
const google_recaptcha_v_3_1 = require("./google-recaptcha-v-3");
const debug_1 = __importDefault(require("debug"));
const debug = debug_1.default('forms:captcha');
exports.captcha = {};
function initCaptcha() {
    debug('init captcha');
    if (env_1.env.GOOGLE_RECAPTCHA_SITE_KEY) {
        debug('Using Google Recaptcha v3');
        exports.captcha.instance = new google_recaptcha_v_3_1.GoogleRecaptchaV3(env_1.env.GOOGLE_RECAPTCHA_SITE_KEY);
    }
    if (!exports.captcha.instance) {
        // eslint-disable-next-line no-console
        console.warn('Captcha is disabled');
        exports.captcha.instance = {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            bind() {
                return __awaiter(this, void 0, void 0, function* () {
                });
            },
            getToken() {
                return __awaiter(this, void 0, void 0, function* () {
                    return undefined;
                });
            },
        };
    }
    return exports.captcha.instance.bind();
}
exports.initCaptcha = initCaptcha;
